import { useState, type FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import { authApi } from "../api/auth";
import { ApiError } from "../api/client";
import "./LoginView.css";

export default function LoginView() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [unverified, setUnverified] = useState(false);
  const [resendMsg, setResendMsg] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setUnverified(false);
    setResendMsg(null);
    setLoading(true);
    try {
      await authApi.login(email, password);
      navigate("/", { replace: true });
    } catch (err) {
      const msg = err instanceof ApiError ? err.message : "Login failed";
      setError(msg);
      setUnverified(msg.toLowerCase().includes("not verified"));
    } finally {
      setLoading(false);
    }
  };

  const resend = async () => {
    setResendMsg(null);
    try {
      const r = await authApi.resendVerification(email);
      setResendMsg(r.message);
    } catch {
      setResendMsg("Could not resend right now — try again shortly.");
    }
  };

  return (
    <div className="login-shell">
      <form className="login-card" onSubmit={submit}>
        <h1>chatter</h1>
        <label>
          Email
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="username"
            required
          />
        </label>
        <label>
          Password
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
        </label>
        {error && <div className="login-error">{error}</div>}
        {unverified && (
          <button type="button" className="login-link-btn" onClick={resend}>
            Resend verification email
          </button>
        )}
        {resendMsg && <div className="login-hint">{resendMsg}</div>}
        <button type="submit" disabled={loading}>
          {loading ? "Signing in…" : "Sign in"}
        </button>
        <div className="login-footer-links">
          <Link to="/forgot-password">Forgot password?</Link>
          <Link to="/signup">Have an invite code? Sign up</Link>
        </div>
      </form>
    </div>
  );
}
